import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

import type * as models from '../../models'

export const DOC = gql`
  query Files($tenantId: ID!, $zoneId: ID!) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        files {
          appId
          extension
          id
          isPrivate
          qualifier
          scenarioId
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.FilesQuery,
    readonly models.File.Listed[] | undefined,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'files',
        graphql.transformers.OUT.list(
          graphql.transformers.OUT.object({
            appId: transformers.PASS_THROUGH,
            extension: transformers.PASS_THROUGH,
            id: graphql.transformers.OUT.nonNull(transformers.PASS_THROUGH),
            isPrivate: graphql.transformers.OUT.default(
              transformers.PASS_THROUGH,
              false,
            ),
            qualifier: transformers.PASS_THROUGH,
            scenarioId: transformers.PASS_THROUGH,
          }),
          { onNullish: 'remove' },
        ),
      ),
    ),
  ),
  [],
)

export const execute = graphql.createExecutor<
  graphql.schema.FilesQuery,
  readonly models.File.Listed[],
  graphql.schema.FilesQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
